module.exports = __webpack_public_path__ + "static/img/ai2.6b5931c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ai2.jpg
// module id = 1zP8
// module chunks = 0